export default __webpack_public_path__ + "static/media/ReiseWelt.b2f72ab65b13ca7f30e9a8e0d8b4aee6.webp";